import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Input } from "@/components/ui/input";
import { api } from "@/lib/api";
import { useCategories } from "@/hooks/useMeta";
import { Page } from "@/components/layout/Layout";
import { ProductCard } from "@/components/common/Cards";
import { Loading, Empty, ErrorBox } from "@/components/common/States";
import SEO from "@/components/common/SEO";

export default function Catalog() {
  const [params, setParams] = useSearchParams();
  const { data: cats = [] } = useCategories();
  const [q, setQ] = useState(params.get("q") || "");
  const category = params.get("category") || "";
  const qs = new URLSearchParams({ ...(category && { category }), ...(params.get("q") && { q: params.get("q") }), limit: "60" }).toString();
  const { data, isLoading, isError } = useQuery({ queryKey: ["products", qs], queryFn: async () => (await api.get(`/products?${qs}`)).data });
  const setCat = (c) => setParams(c ? { category: c, ...(q && { q }) } : q ? { q } : {});

  const selectedCat = cats.find((c) => c.slug === category);
  const catalogTitle = selectedCat ? `${selectedCat.name} Ürün Kataloğu` : "Teknik Ürün Kataloğu";
  const catalogDesc = selectedCat
    ? `${selectedCat.name} kategorisindeki tüm FPV parçalarının teknik verileri, pinout şemaları ve karşılaştırma özellikleri.`
    : "FPV motor, FC, ESC, kamera, VTX ve anten modellerinin doğrulanmış teknik özellikleri ve parça kataloğu.";

  return (
    <Page>
      <SEO
        title={catalogTitle}
        description={catalogDesc}
        canonical={`https://createfpv.com/katalog${qs ? `?${qs}` : ""}`}
      />
      <p className="eyebrow">Ürün kataloğu</p>
      <h1 className="font-display text-4xl sm:text-5xl font-semibold">Teknik katalog</h1>
      <p className="mt-2 max-w-2xl text-zinc-500">Her model tek bir kayıttır; ilanlar, yorumlar ve karşılaştırmalar bu kayda bağlanır. Aktif ilanı olmayan modelleri de karşılaştırabilirsiniz.</p>
      <div className="mt-6 flex flex-wrap gap-2">
        <button onClick={() => setCat("")} data-testid="catalog-cat-all" className={`rounded-full border px-3 py-1.5 text-sm ${!category ? "border-[#0071e3] bg-[#0071e3] text-white" : "border-black/[0.08] text-zinc-500"}`}>Tümü</button>
        {cats.map((c) => (
          <button key={c.slug} onClick={() => setCat(c.slug)} data-testid={`catalog-cat-${c.slug}`}
            className={`rounded-full border px-3 py-1.5 text-sm ${category === c.slug ? "border-[#0071e3] bg-[#0071e3] text-white" : "border-black/[0.08] text-zinc-500"}`}>{c.name}</button>
        ))}
      </div>
      <Input data-testid="catalog-page-search" className="mt-4 max-w-md" placeholder="Marka / model ara, Enter'a basın" value={q}
        onChange={(e) => setQ(e.target.value)} onKeyDown={(e) => e.key === "Enter" && setParams({ ...(category && { category }), ...(q && { q }) })} />
      <div className="mt-8">
        {isLoading && <Loading />}
        {isError && <ErrorBox />}
        {data && (data.items.length ? (
          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4" data-testid="catalog-results">{data.items.map((p) => <ProductCard key={p.id} p={p} />)}</div>
        ) : <Empty />)}
      </div>
    </Page>
  );
}
